import { useNavigate } from "react-router-dom";

import FlightIcon from "@mui/icons-material/Flight";
import HotelIcon from "@mui/icons-material/Hotel";
import NotificationsActiveIcon from "@mui/icons-material/NotificationsActive";
import StarPurple500Icon from "@mui/icons-material/StarPurple500";
import { Divider, MenuItem, MenuList } from "@mui/material";

import { AlertTypeEnum } from "@/constants";

interface AlertMenuProps {
  onClose: () => void;
  onShowAlert: (type: AlertTypeEnum) => void;
}

const list = [
  {
    label: "Real-time Alert",
    type: AlertTypeEnum.Flight,
    icon: (
      <FlightIcon color="primary" sx={{ fontSize: "18px" }} className="mr-[10px] rotate-[45deg]" />
    ),
  },
  {
    label: "Panorama Alert",
    type: AlertTypeEnum.Panorama,
    icon: <StarPurple500Icon color="primary" sx={{ fontSize: "18px" }} className="mr-[10px]" />,
  },
  {
    label: "Hotel Alert",
    type: AlertTypeEnum.Hotel,
    icon: <HotelIcon color="primary" sx={{ fontSize: "18px" }} className="mr-[10px]" />,
  },
];
const AlertMenu = (props: AlertMenuProps) => {
  const navigate = useNavigate();

  return (
    <>
      <MenuList>
        {list.map((item) => {
          return (
            <MenuItem
              key={item.type}
              onClick={() => {
                props.onClose();
                props.onShowAlert(item.type);
              }}
            >
              <div className="flex items-center gap-1">
                {item.icon} {item.label}
              </div>
            </MenuItem>
          );
        })}
        <Divider />
        <MenuItem
          onClick={() => {
            props.onClose();
            navigate("/alert");
          }}
        >
          <div className="flex items-center gap-1">
            <NotificationsActiveIcon
              color="primary"
              sx={{ fontSize: "18px" }}
              className="mr-[10px]"
            />
            Manage Alerts
          </div>
        </MenuItem>
      </MenuList>
    </>
  );
};
export default AlertMenu;
